<!-- /* 该文件为模版类 入口文件 */ -->
<template>
  <section class="app" v-if="isReady">
    <common-header v-if="$route.name !== 'getMarketDepthBlank'" :headerActive="headerActive"
      @setHeaderActive="setHeaderActive" />

    <router-view v-if="$route.name === 'homeT'"></router-view>
    <div class="app-body" :class="{ handDealBlank: $route.name === 'getMarketDepthBlank' }" v-else>
      <app-sidebar fixed>
        <sidebar-nav :headerActive="headerActive" :open="sideBarOpen" :active="sideBarActive" @setOpen="setOpen"
          @setActive="setActive" @setCollapse="setCollapse">
        </sidebar-nav>
      </app-sidebar>
      <main class="main" :style="{
    marginLeft: isCollapse ? '224px !important' : '350px !important',
  }">
        <!-- 导向 -->
        <div>
          <rightTab ref="routerTab" :style="{
    left: isCollapse ? '235px !important' : '360px !important'
  }"></rightTab>


          <div class="container-fluid">
            <el-scrollbar style="height:88vh;" ref="scrollbar">
              <router-view v-if="isRouterAlive"></router-view>
            </el-scrollbar>
          </div>

          <!-- <div class="container-fluid">

            <router-view v-if="isRouterAlive"></router-view>

          </div> -->

        </div>
      </main>
    </div>
  </section>
  <section v-else></section>
</template>

<script>
import { Sidebar as appSidebar } from "@coreui/vue";
import commonHeader from "./header";
import sidebarNav from "./sidebar.vue";
import rightTab from "./rightTab.vue";

export default {
  name: "DefaultContainer",
  provide() {
    return {
      reload: this.reload,
    };
  },
  components: {
    commonHeader,
    appSidebar,
    sidebarNav,
    rightTab,
  },
  data() {
    return {
      isReady: false,
      headerActive: "", // header 选中
      sideBarOpen: "", // 侧边栏 展开的栏目
      sideBarActive: "", // 侧边栏 选中的栏目
      isRouterAlive: true,
      isCollapse: false,
    };
  },
  created() {
    this.$store.dispatch("getMenus");
    if (this.menus) {
      this.isReady = true;
      this.setRouter();
    }
  },
  watch: {
    menus(v) {
      if (v) {
        this.isReady = true;
        this.setRouter();
      }
    },
    $route: {
      handler(val) {
        if (this.menus) {
          this.setRouter();
        }
        if (this.$route.path != "/") {
          this.$refs.routerTab.addTab();
        }
      },
      deep: true,
    },
  },
  computed: {
    menus() {
      return this.$store.state.baseData.menus;
    },
    menusFilter() {
      return this.$store.state.baseData.menusFilter;
    },
    HeaderAtName() {
      return this.$store.state.baseData.HeaderAtName;
    },
    HeaderChildName() {
      return this.$store.state.baseData.HeaderChildName;
    },
    HeaderActive() {
      let str = this.HeaderAtName;
      if (this.HeaderChildName && this.HeaderChildName.length) {
        str = this.HeaderChildName;
      }
      return str;
    },
    name() {
      return this.$route.name;
    },
  },
  methods: {
    setHeaderActive(v) {
      this.headerActive = v;
      // 获取到该header栏目下的 sideBar列表
      let sideBarMenus = this.menus.menuList[v];
      if (sideBarMenus && sideBarMenus.length) {
        // 获取该sideBar栏目下的 第一个栏目
        let obj = sideBarMenus[0];
        let active = "";
        let open = "";
        // 如果该栏目存在子栏目
        if (obj.child.length) {
          open = obj.atName;
          active = obj.child[0].atName;
          // 如果不存在
        } else {
          active = obj.atName;
        }
        this.$router.push(active);
        this.$nextTick(() => {
          this.sideBarOpen = open;
          this.sideBarActive = active;
        });
      }
    },
    setRouter() {
      let obj = this.menusFilter[this.$route.name];
      // 前端存在该路由 但不在服务端返回的列表中
      if (obj) {
        this.headerActive = obj.header;
        // 如果该栏目为含二级栏目
        let open = "";
        let active = this.$route.name;
        if (obj.first) {
          open = obj.first;
        }
        this.$nextTick(() => {
          this.sideBarOpen = open;
          this.sideBarActive = active;
        });
      } else {
        //
      }
    },
    setOpen(v) {
      this.sideBarOpen = v;
    },
    setActive(item) {
      // this.$router.push(v);
      if (this.$route.path != "/") {
        this.$refs.routerTab.addTab(item);
      }
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    // 获取折叠菜单状态
    setCollapse(val) {
      this.isCollapse = val;
    },
    // 获取菜单
    getMenus() {
      this.$http({
        url: "menus",
      }).then((data) => {
        if (data.code.toString() === "0") {
          this.$nextTick(() => {
            setTimeout(() => {
              if (this.$route.path !== "/" && this.$refs.routerTab) {
                this.$refs.routerTab.addTab("", "Refresh");
              }
            }, 1000);
          });
        }
      });
    },
  },
  mounted() {
    this.getMenus();
    // setTimeout(() => {
    //   this.$nextTick(() => {
    //     const scr = this.$refs.scrollbar.$el; // 获取<el-scrollbar>的DOM节点
    //     const observer = new ResizeObserver(() => {
    //       this.$refs.scrollbar.update();
    //     });
    //     observer.observe(scr); // 监听高度变化
    //   });
    // }, 1000);

  }
};
</script>

<style lang="scss">
// 滚动条颜色 宽度
.el-scrollbar {
  border-radius: 0px 0px 16px 16px !important;
}

.el-scrollbar__thumb {
  background: #F3F4F8  !important;

}

.el-scrollbar__bar.is-horizontal {
  height: 8px !important; //水平
  display: none;
}

.el-scrollbar__bar.is-vertical {
  width: 8px !important; //垂直
}

.right-tab {
  position: fixed;
  top: 28px;
  max-width: 1000px;
  z-index: 1001;

  #tab-1 {
    .el-icon-close {
      opacity: 0;
      position: relative;
      top: -30px;
    }
  }

  .el-tabs__header {
    margin: 0;
    border-bottom: none;

    .el-tabs__nav {
      border: none;
    }

    .el-tabs__item {
      border: none;
    }

    .el-icon-close {
      color: #303133;
      background: none !important;

      &:hover {
        color: #095be8;
      }
    }

    .el-tabs__nav-prev {
      font-size: 14px;
      left: 779px;
      top: -4px;

      &:hover {
        color: #095be8;
      }
    }

    .el-tabs__nav-next {
      font-size: 14px;
      right: 6px;
      top: -4px;

      &:hover {
        color: #095be8;
      }
    }

    .el-tabs__nav-wrap.is-scrollable {
      padding: 0 60px 0 0;
    }
  }

  .el-tabs__item {
    padding: 0 10px 0 20px !important;
    color: #93979d;
    height: 32px !important;
    line-height: 32px !important;
    font-size: 14px;
    position: relative;
    display: inline-block;
    font-family: HarmonyOS-Regular;

    &.is-active {
      background: #f3f6fa;
      border-radius: 8px 8px 0px 0px;
      color: #24324c;
      font-family: HarmonyOS-Regular;
    }

    &:hover {
      background: rgba(243, 246, 250, 0.5);
      border-radius: 8px 8px 0px 0px;
      color: #93979d;
      font-family: HarmonyOS-Regular;
    }

    .el-icon-close {
      width: 14px !important;
    }
  }
}

@media (min-width: 992px) {
  .handDealBlank {
    margin-top: 0px !important;
  }
}

@media (max-width: 992px) {
  .handDealBlank {
    margin-top: 0 !important;
  }
}

.handDealBlank {
  background: #fff;

  .main .container-fluid {
    padding: 0 !important;
  }
}
</style>
